import { EntitySource } from 'src/constants';
import { IMenu } from 'src/types/menu.types';

export const getCompatibleMenus = (menus: IMenu[], source: EntitySource, rangeIds: string[]): IMenu[] =>
  menus
    .filter(
      ({ ranges = [] }) => source !== EntitySource.RANGES || ranges.some(({ range_id }) => rangeIds.includes(range_id)),
    )
    .sort((a, b) => a.name.localeCompare(b.name));
